import React, { useContext } from 'react'
import { SharedValue } from 'react-native-reanimated'

type ModalContextType = {
  close: () => void
  animation: SharedValue<number>
  isClosing: SharedValue<boolean>
}
export const ModalContext = React.createContext<null | ModalContextType>(null)

const useModalContext = () => {
  const ctx = useContext(ModalContext)
  if (!ctx) {
    throw new Error('ModalContext is not provided')
  }
  return ctx
}

export default useModalContext
